module.exports = __webpack_public_path__ + "img/icon-headset.e3a6a141.svg";